import styled from '@emotion/styled'
import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import EmailSentAnimation from '@public/static/images/animations/EmailSent.json'
import dynamic from 'next/dynamic'
import { TitleSection } from '../../styled.components'
import { useTranslation } from 'next-i18next'

// Dynamic import of Lottie with SSR disabled
const Lottie = dynamic(() => import('react-lottie'), {
  ssr: false,
  loading: () => <div style={{ minHeight: '200px', width: '100%' }} />,
})

type Props = {
  onClose: () => void
  setCurrentStep: Dispatch<
    SetStateAction<
      'stepone' | 'steptwo' | 'stepthree' | 'stepfour' | 'stepfive'
    >
  >
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin: 3rem auto;
  max-width: 340px;
  justify-content: center;
  align-items: center;
  margin-top: 0.6rem;
`
const AnimationWrapper = styled.div`
  width: 220px;
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`
const MessageWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;
`
const BottomMessage = styled.div`
  font-family: var(--font-inter);
  font-weight: 600;
  margin-top: 1rem;
`

const StepFive = ({ onClose, setCurrentStep }: Props) => {
  const [seconds, setSeconds] = useState(5)
  const { t } = useTranslation(['landingPage'])

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => (prev !== 0 ? prev - 1 : 0))
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  useEffect(() => {
    if (seconds === 0) {
      onClose()
      setCurrentStep('stepone')
    }
  }, [seconds])

  return (
    <Container>
      <AnimationWrapper>
        <Lottie
          options={{
            loop: false, // Set to true if you want the animation to loop
            autoplay: true,

            rendererSettings: {
              // preserveAspectRatio: 'xMidYMid slice',
            },
            animationData: EmailSentAnimation,
          }}
        />
      </AnimationWrapper>
      <MessageWrapper>
        <TitleSection>{t('connectWithUs.stepFive.title')}</TitleSection>
        <span className="text-center font-[Inter]">
          {t('connectWithUs.stepFive.description')}
        </span>
      </MessageWrapper>
      <BottomMessage>
        {t('connectWithUs.stepFive.autoClose')}{' '}
        <span className="text-uguBrightPurple">{seconds}</span>{' '}
        {t('connectWithUs.stepFive.sec')}
      </BottomMessage>
    </Container>
  )
}

export default StepFive
